var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import moment from "moment";
import { SORT_TYPES } from "../constants/enums";
import Message from "../components/message/message";
import _ from "./lodashUtils";
var Helpers = /** @class */ (function () {
    function Helpers() {
    }
    Helpers.isNonNullObject = function (obj) {
        return typeof obj === "object" && obj !== null;
    };
    Helpers.noop = function () { return null; };
    Helpers.onSortByDate = function (column, data, sortBy) {
        return data.sort(function (element1, element2) {
            if (sortBy === SORT_TYPES.ASC) {
                return moment(element1[column.accessor]).diff(moment(element2[column.accessor]));
            }
            return moment(element2[column.accessor]).diff(moment(element1[column.accessor]));
        });
    };
    Helpers.onSortByString = function (column, data, sortBy) {
        return data.sort(function (element1, element2) {
            if (sortBy === SORT_TYPES.ASC) {
                return element1[column.accessor].localeCompare(element2[column.accessor]);
            }
            return element2[column.accessor].localeCompare(element1[column.accessor]);
        });
    };
    Helpers.onSortByNumber = function (column, data, sortBy) {
        return data.sort(function (element1, element2) {
            if (sortBy === SORT_TYPES.ASC) {
                return (Number(element1[column.accessor]) - Number(element2[column.accessor]));
            }
            return (Number(element2[column.accessor]) - Number(element1[column.accessor]));
        });
    };
    Helpers.padWithLeadingZeroes = function (n, width) {
        var num = "" + n;
        return num.length >= width
            ? n
            : new Array(width - num.length + 1).join("0") + num;
    };
    Helpers.getSelectOptions = function (rawOptions, labelKey, valueKey) {
        return rawOptions.map(function (rawOption) { return (__assign({}, rawOption, { label: _.get(rawOption, "" + labelKey, ""), value: _.get(rawOption, "" + valueKey, "") })); });
    };
    Helpers.convertQueryParamsToString = function (queryParams) {
        var url = "";
        var count = 0;
        for (var property in queryParams) {
            if (queryParams.hasOwnProperty(property)) {
                count += 1;
                url += "" + (count <= 1 ? "?" : "&") + property + "=" + queryParams[property];
            }
        }
        return url;
    };
    Helpers.convertQueryStringToObject = function (queryParams) {
        var transformedObject = {};
        var firstSplit = queryParams.split("?");
        var firstObjects = firstSplit.length > 1 ? firstSplit[1].split("&") : [];
        firstObjects.forEach(function (obj) {
            var keyValuePair = obj.split("=");
            if (keyValuePair[1] !== "undefined") {
                transformedObject[keyValuePair[0]] = keyValuePair[1];
            }
        });
        return transformedObject;
    };
    Helpers.isEmailValid = function (email) {
        var re = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
        return re.test(String(email).toLowerCase());
    };
    Helpers.downloadCSVFile = function (data, fileName) {
        if (fileName === void 0) { fileName = "form_template"; }
        var hiddenElement = document.createElement("a");
        hiddenElement.href = "data:text/csv;charset=utf-8," + encodeURI(data);
        hiddenElement.target = "_blank";
        hiddenElement.download = (_.isEmpty(fileName) ? "form_template" : fileName) + ".csv";
        hiddenElement.click();
    };
    Helpers.notifySuccess = function (messageString, durationInSeconds) {
        Message.success(messageString, durationInSeconds);
    };
    Helpers.notifyError = function (messageString, durationInSeconds) {
        Message.error(messageString, durationInSeconds);
    };
    Helpers.toTitleCase = function (s) {
        if (typeof s !== "string")
            return "";
        return s.charAt(0).toUpperCase() + s.slice(1);
    };
    Helpers.getCurrentTabName = function (_a, tabnameIndex, defaultTabname) {
        var pathname = _a.pathname;
        return pathname.split("/")[tabnameIndex] || defaultTabname;
    };
    Helpers.getOptionWithValue = function (options, value) {
        return (options &&
            options.filter(function (option) { return option.value === value; })[0]);
    };
    return Helpers;
}());
export default Helpers;
//# sourceMappingURL=helpers.js.map